import type { SVGProps } from "react";
const SvgArrowExpand02Round = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.97 11.03a.75.75 0 1 0 1.06-1.06l-.53.53zM4.03 2.97a.75.75 0 0 0-1.06 1.06l.53-.53zm6.47 7.53.53-.53-7-7-.53.53-.53.53 7 7zM19.97 21.03a.75.75 0 1 0 1.06-1.06l-.53.53zm-5.94-8.06a.75.75 0 1 0-1.06 1.06l.53-.53zm6.47 7.53.53-.53-7-7-.53.53-.53.53 7 7z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.5 3.266c-.844-.012-3.64-.593-4.234 0s-.012 3.39 0 4.234M20.734 16.5c.012.844.593 3.64 0 4.234s-3.39.012-4.234 0"
    />
  </svg>
);
export default SvgArrowExpand02Round;
